import React, { useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import communityData from "./communityData";
import {
  sliderImg7,
  sliderImg2,
  sliderImg3,
  sliderImg4,
  sliderImg5,
  sliderImg6,
} from "../../../assets/img";
import { IoCheckmarkDoneSharp } from "react-icons/io5";
import {
  BsFill1SquareFill,
  BsFill2SquareFill,
  BsFill3SquareFill,
  BsFill4SquareFill,
  BsFill5SquareFill,
} from "react-icons/bs";
// Adjust the path as per your project structure

const Arr = [
  { img:  sliderImg7 , title: "1st", rank: <BsFill1SquareFill />, bgColor:'gold' },
  { img:  sliderImg6 , title: "2nd", rank: <BsFill2SquareFill />, bgColor:'silver' },
  { img:  sliderImg5 , title: "3rd", rank: <BsFill3SquareFill />, bgColor:'brown' },
  { img:  sliderImg4 , title: "4th", rank: <BsFill4SquareFill />, bgColor:'purple' },
  { img:  sliderImg3 , title: "5th", rank: <BsFill5SquareFill />, bgColor:'green' },
];

const Community = () => {
  const [visibleUsers, setVisibleUsers] = useState(3); // State to control how many users to display

  const showMoreUsers = () => {
    setVisibleUsers((prevVisibleUsers) => prevVisibleUsers + 5); // Show 8 more users when the button is clicked
  };

  return (
    <div>
      <Row>
        <h2>Lead Investors</h2>
      </Row>

      {/* First row: displaying first 3 objects */}
      <Row className="d-flex justify-content-center align-items-center m-4">
        {Arr.slice(0, 3).map((item, index) => (
          <Col lg="4" className="d-flex " key={index}>
            <img
              style={{ height: "150px", width: "170px", borderRadius: "30px" }}
              src={item.img} // Dynamically rendering the img property from the array
              alt={`Investor ${index + 1}`}
            />
            <div className="ml-2">
              <span
                style={{
                  color: "white",
                  background: item.bgColor,
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  padding: "5px",
                  borderRadius: "5px",
                  textAlign: "center",
                }}
              >
                Top {item.rank} {/* Dynamically rendering the rank */}
              </span>
              <h3 className="mt-3">{item.title} Investor</h3>{" "}
              {/* Dynamically rendering title */}
            </div>
          </Col>
        ))}
      </Row>

      {/* Second row: displaying the remaining 2 objects */}
      <Row className="d-flex justify-content-center align-items-center m-4 mt-5">
        {Arr.slice(3, 5).map((item, index) => (
          <Col lg="6" className="d-flex " key={index + 3}>
            <img
              style={{ height: "150px", width: "170px", borderRadius: "30px" }}
              src={item.img} // Dynamically rendering the img property from the array
              alt={`Investor ${index + 4}`}
            />
            <div className="ml-2">
              <span
                style={{
                  color: "white",
                  background: item.bgColor,
                  fontSize: "1.1rem",
                  fontWeight: "bold",
                  padding: "5px",
                  borderRadius: "5px",
                  textAlign: "center",
                }}
              >
                Top {item.rank} {/* Dynamically rendering the rank */}
              </span>
              <h3 className="mt-3">{item.title} Investor</h3>{" "}
              {/* Dynamically rendering title */}
            </div>
          </Col>
        ))}
      </Row>

      <hr />
      <Row>
        <h2>What our investors say</h2>
      </Row>

      {/* Render only the number of users set by visibleUsers */}
      {communityData.slice(0, visibleUsers).map((user, index) => (
        <Row className="mt-4 ml-2 d-flex" key={index}>
          <Col lg="1">
            <img
              src={user.image} // Dynamically setting the image from the communityData
              style={{
                height: "90px",
                width: "90px",
                borderRadius: "20px",
              }}
              alt={user.username} // Using username for alt attribute
            />
          </Col>
          <Col lg="7">
            <div className="d-flex flex-column ml-4">
              <h3>{user.username}</h3> {/* Displaying the username */}
              <span className="mt-1">{user.bio}</span>{" "}
              {/* Displaying the bio */}
              <p
                className="p-2 mt-4"
                style={{
                  backgroundColor: "#e6e6e7",
                  borderRadius: "10px",
                }}
              >
                {user.paragraph} {/* Displaying the random paragraph */}
              </p>
            </div>
          </Col>
        </Row>
      ))}

      {/* Show the "Show More" button only if there are more users to display */}
      {visibleUsers < communityData.length && (
        <Row className="mt-3">
          <Col className="d-flex justify-content-center">
            <Button
              onClick={showMoreUsers}
              variant="primary"
              style={{ padding: "10px 20px", fontSize: "16px" }}
            >
              Show More
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Community;
